import {
  type CardDraftBulkImport,
  type BulkImportStore,
} from '@/components/BulkImportModal/store/bulk-import.store.types'
import {
  BASE_MULTIPLE_CHOICE_FIELD_VALUES,
  type CardActivityType,
  type CardActivityWithId,
} from '@/models/card-activity/card-activity.model'
import { handleGenerateMultipleChoiceOptions } from '@/utils/generateMultipleChoiceOptions'

export async function enrichMCCard(
  cardType: CardActivityType,
  cardDraft: CardDraftBulkImport & { id: string },
  settings: BulkImportStore['settings'],
) {
  const baseMCCard: Partial<CardActivityWithId> = {
    allowRetries: true,
    id: cardDraft.id,
    type: cardType,
    question: cardDraft.prompt,
    MCQType: settings.selectType,
    points: settings.points,
    language: settings.language,
    default_language: settings.defaultLanguage,
  }

  const answers = await handleGenerateMultipleChoiceOptions(cardDraft.prompt, settings.selectType === 'multi')

  if (answers.error) {
    baseMCCard.answer = BASE_MULTIPLE_CHOICE_FIELD_VALUES.answer
    baseMCCard.choices = BASE_MULTIPLE_CHOICE_FIELD_VALUES.choices
  } else {
    baseMCCard.answer = answers.answers
    baseMCCard.choices = answers.choices
  }

  return baseMCCard
}
